<template>
  <div class="flex-grow pr-2">
    <div class="rounded-2xl p-2 pl-3 pr-3 text-left relative inline-block float-right bg-indigo-100" :style="customWidthStyle">
      <FileAttachments v-on:image-width="handleImageWidthLimit" :message="message" />
      <p class="whitespace-pre-line break-words max-w-screen-sm relative">
        <span class="mr-2 clear-both max-w-md" :class="{'block': textIsLong, 'inline-block pb-1': !textIsLong}"  v-linkify:options="{target: '_blank'}">{{message.text}}</span>
        <span class="text-xs text-gray-600" :class="{'block text-right': textIsLong, 'inline-block align-bottom':!textIsLong}">
          <template v-if="scheduled">
            <span class="flex items-center">
              <span>{{ $t('conversation.scheduled') }}</span>
              <ClockIcon class="flex-shrink-0 mr-1.5 h-5 w-5 text-gray-400" aria-hidden="true" />
            </span>
          </template>
          <template v-else>
            <span v-if="hideStatus">
              {{ $t('conversation.justNow') }}
            </span>
            <span v-else>
              <Datetime v-bind:date="message.created_at" fromNow="true" />
            </span>
            <StatusWidget v-bind:status="message.status" class="inline-block" />
          </template>
        </span>
      </p>
    </div>
  </div>
  <div class="flex-initial">
    <div class="relative h-14">
      <ChannelLabel v-if="channel" :channel="channel" asTooltip="true" />
      <MessageAgent v-bind:agentId="message.agent_id" />
    </div>
  </div>
</template>



<script>
import Datetime from '../../building_blocks/DateTime.vue'
import ChannelLabel from '../parts/ChannelLabel.vue'
import MessageAgent from '../parts/MessageAgent.vue'
import FileAttachments from '../parts/FileAttachments.vue'
import StatusWidget from '../parts/StatusWidget.vue'
import { ClockIcon } from '@heroicons/vue/outline'

export default {
  name: 'AgentMessage',
  props: ['message', 'channel', 'customWidthStyle', 'hideStatus', 'textIsLong'],
  emits: ['image-width'],
  setup() {
  },
  components: {
    Datetime,
    ChannelLabel,
    MessageAgent,
    FileAttachments,
    StatusWidget,
    //
    ClockIcon,
  },
  methods: {
     handleImageWidthLimit(width) {
       this.$emit('image-width', width);
     },
  },
  computed: {
    scheduled() {
      return this.message.status === 'scheduled';
    },
  },
}
</script>
